const PageContentRow = ({children}) =>{
    return <div className="content-page-inner basic container shadow-sm rounded-3">
      <div className="row d-flex flex-wrap">
        {children}
      </div>
    </div>
}

export { PageContentRow }